export const getPublicSlug = () => {
    if (typeof window === 'undefined') return null;
    const match = window.location.pathname.match(/^\/user\/([a-z0-9-]+)/i);
    return match ? match[1] : null;
};

export const createWorkspaceMap = (workspaces, normalizeId) => {
    const map = new Map();
    workspaces.forEach((workspace) => map.set(normalizeId(workspace.id), workspace));
    return map;
};

export const getWorkspaceById = (workspaceMap, normalizeId, workspaceId) =>
    workspaceMap.get(normalizeId(workspaceId));

export const getAssignedCabinetMap = (workspaces) => {
    const map = new Map();
    workspaces.forEach((workspace) => {
        (workspace.cabinets || []).forEach((cabinet) => {
            map.set(cabinet.marketplace_account_id, workspace.id);
        });
    });
    return map;
};

export const getVisibleMarketplaces = (marketplaces) => {
    if (!marketplaces || !marketplaces.length) return [];
    return marketplaces;
};

export const getVisibleWorkspaces = (workspaces, userId, normalizeId, getWorkspaceRole) =>
    workspaces.filter((workspace) => {
        if (!userId) return true;
        const hasOwner = Boolean(workspace.owner_user_id);
        const hasRole = Boolean(getWorkspaceRole(workspace));
        if (!hasOwner && !hasRole) return true;
        const isOwner = normalizeId(workspace.owner_user_id) === normalizeId(userId);
        return isOwner || hasRole;
    });

export const getUserCabinets = (marketplaces, user, normalizeId) => {
    if (!user) return [];
    return marketplaces.filter((account) => {
        const hasOwner = Boolean(account.owner_user_id);
        const hasRole = Boolean(account.my_role);
        if (!hasOwner && !hasRole) return true;
        const isOwner = normalizeId(account.owner_user_id) === normalizeId(user.id);
        return isOwner || hasRole;
    });
};

export const getAvailableProjectCabinets = (marketplaces, assignedCabinetMap, projectEditId) =>
    marketplaces.filter((account) => {
        const assignedTo = assignedCabinetMap.get(account.id);
        if (!assignedTo) return true;
        return assignedTo === projectEditId;
    });
